import type { FieldValue, FieldValues } from '@atlassian/proforma-form-renderer/field-values';
import {
	asDateValue,
	asLocalTimeValue,
	asNumberValue,
	asOptionsValue,
	asTextValue,
} from '@atlassian/proforma-form-renderer/field-values/utils';
import {
	type FormQuestion,
	type ProformaForm,
	FormQuestionType,
} from '@atlassian/proforma-form-renderer/proforma-form';

export const requestBody = (
	projectId: number,
	requestTypeId: number,
	currentValues: FieldValues,
	proformaForm: ProformaForm,
	query: string,
	reporterAccountId?: string,
): string => {
	return JSON.stringify({
		query,
		fieldValueMap: {
			...(reporterAccountId ? { reporter: reporterAccountId } : {}),
			...(Object.fromEntries(
				Object.entries(currentValues)
					.map(([fieldId, fieldValue]) => {
						const formQuestion = proformaForm.design.questions[fieldId];
						const jiraFieldId = formQuestion?.jiraField;
						return jiraFieldId
							? [jiraFieldId, asContext(fieldValue, formQuestion)]
							: [undefined, undefined];
					})
					.filter(([_, fieldValue]) => fieldValue !== undefined),
			) as Record<string, FieldValue | undefined>),
			pid: projectId.toString(),
			requesttype: requestTypeId.toString(),
		},
	});
};

const asContext = (fieldValue: FieldValue, formQuestion: FormQuestion) => {
	switch (formQuestion.type) {
		case FormQuestionType.Date:
			return asDateValue(fieldValue)?.date;
		case FormQuestionType.Time:
			return asLocalTimeValue(fieldValue)?.localTime;
		case FormQuestionType.Number:
			return asNumberValue(fieldValue)?.number.toString();
		case FormQuestionType.ChoiceDropdown:
		case FormQuestionType.ChoiceDropdownMultiple:
		case FormQuestionType.ChoiceMultiple:
		case FormQuestionType.ChoiceSingle:
		case FormQuestionType.CmdbObject:
		case FormQuestionType.UserMultiple:
		case FormQuestionType.UserSingle:
			return asOptionsValue(fieldValue)
				?.options.map((option) => option.id)
				.join(',');
		case FormQuestionType.TextEmail:
		case FormQuestionType.TextLong:
		case FormQuestionType.TextParagraph:
		case FormQuestionType.TextShort:
		case FormQuestionType.TextUrl:
			return asTextValue(fieldValue)?.text;
		default:
			return undefined;
	}
};
